import React from 'react';
interface PillProps {
  children: React.ReactNode;
  tone?: 'navy' | 'lime' | 'shell';
  className?: string;
}
export function Pill({
  children,
  tone = 'navy',
  className = ''
}: PillProps) {
  const tones: Record<string, string> = {
    navy: 'border-navy/20 bg-navy-light text-navy',
    lime: 'border-lime-ink/30 bg-lime-soft text-lime-ink',
    shell: 'border-shell/25 bg-shell/10 text-shell'
  };
  return <span className={`inline-flex items-center rounded-full border px-4 py-1.5 font-sans text-[10px] font-semibold uppercase tracking-[0.2em] ${tones[tone]} ${className}`} data-id="element-140" data-mp="1axeh43li7j9s">
      {children}
    </span>;
}